<template>
  <div :id="id" class="qr-code-box-scanner">
    <qrcode-stream @decode="onDecode" @init="onInit">
      <div
        v-if="!granted_camera"
        class="text-center text-primary d-flex flex-column align-items-center justify-content-center h-100"
      >
        <b-spinner></b-spinner>
      </div>
      <div
        v-if="error"
        class="text-center text-negative-500 d-flex flex-column align-items-center justify-content-center h-100"
      >
        <i class="fa-regular fa-camera-slash fs-32"></i>
        <span class="mt-5 fs-14">Câmera não encontrada.</span>
        <span class="fs-14 px-6"
          >Tente novamente, ou faça check-in através da lista de
          participantes.</span
        >
      </div>
    </qrcode-stream>
    <div v-if="!error" class="scan-line"></div>
  </div>
</template>
<script>
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  components: { QrcodeStream },
  props: {
    id: {
      type: String,
      default: "bp-qr-code-full-region",
      required: true
    }
  },
  data() {
    return {
      error: null,
      granted_camera: false
    };
  },
  methods: {
    onDecode(res) {
      this.$emit("ondecode", res);
    },
    async onInit(promise) {
      try {
        const response = await promise;
      } catch (e) {
        if (e.name === "NotAllowedError")
          this.error = "Permita o acesso à câmera.";
      } finally {
        this.granted_camera = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.qr-code-box-scanner {
  border-radius: 4px;
  border: 2px solid #9849ff !important;
  width: 298px;
  height: 280px;
  position: relative;
  overflow: hidden;

  @keyframes scan {
    0%,
    100% {
      transform: translateX(-50%) translateY(0);
    }
    50% {
      transform: translateX(-50%) translateY(-270px);
    }
  }

  .scan-line {
    position: absolute;
    border: 2px solid #9849ff;
    width: 100%;
    left: 50%;
    bottom: 0;
    animation: scan 2.5s infinite;
  }
}
</style>
